import { Injectable } from '@angular/core';
import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it';

const parserOptions = {
  html: false,
  breaks: true,
  linkify: false,
  typographer: false,
} as const;

const renderer = new MarkdownIt(parserOptions);
const validator = new MarkdownIt({ ...parserOptions, html: true });
validator.validateLink = () => true;
const allowedBlockTokens = new Set(['paragraph_open', 'inline', 'paragraph_close']);
const allowedInlineTokens = new Set(['text', 'softbreak', 'strong_open', 'strong_close']);

export function isMarkdownV1(source: string): boolean {
  if (source.trim().length === 0) {
    return false;
  }

  return validator.parse(source, {}).every(token => {
    if (!allowedBlockTokens.has(token.type)) {
      return false;
    }
    if (token.type !== 'inline') {
      return true;
    }
    return (
      token.children?.every(child => {
        if (!allowedInlineTokens.has(child.type)) {
          return false;
        }
        return !child.type.startsWith('strong_') || child.markup === '**';
      }) ?? false
    );
  });
}

@Injectable({
  providedIn: 'root',
})
export class AnnouncementMarkdownService {
  render(source: string): string {
    if (!isMarkdownV1(source)) {
      return '';
    }

    return DOMPurify.sanitize(renderer.render(source), {
      ALLOWED_TAGS: ['p', 'br', 'strong'],
      ALLOWED_ATTR: [],
    });
  }
}
